import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13.998 20.003v-16h5a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-5z","key":"svg-0"}],["path",{"d":"M8.998 20.003h.01","key":"svg-1"}],["path",{"d":"M3.997 20.003h.011","key":"svg-2"}],["path",{"d":"M3.997 15.002h.011","key":"svg-3"}],["path",{"d":"M3.997 9.002h.011","key":"svg-4"}],["path",{"d":"M3.997 4.002h.011","key":"svg-5"}],["path",{"d":"M8.998 4.002h.01","key":"svg-6"}]]

const IconBoxAlignRight = createReactComponent('outline', 'box-align-right', 'BoxAlignRight', __iconNode);

export default IconBoxAlignRight;